import { RhButton } from "@rhythm-ui/react";
import React from "react";

type GenericType<T> = {
  values?: T;
  valueKey?: (keyof T)[];
  handleClearFilterKey: (keys: (keyof T)[]) => void;
  title: string;
  subTitle?: string;
};

const FilterHeader = <T extends object>({
  // values,
  valueKey,
  handleClearFilterKey,
  title,
  subTitle,
}: GenericType<T>) => {
  // const isFilterUsed = useMemo(
  //   () => valueKey.some((key) => values[key] || values[key] === 0),
  //   [values]
  // );

  return (
    <div className="flex items-center justify-between ">
      <div className="[&>*]:inline">
        <h5>{title}</h5>{" "}
        {subTitle && <p className="body-small text-hint">{subTitle}</p>}
      </div>

      <RhButton
        className="button-tertiary button-sm"
        onClick={() => valueKey && handleClearFilterKey(valueKey)}
        // disabled={!isFilterUsed}
      >
        Clear
      </RhButton>
    </div>
  );
};

export default FilterHeader;
